// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./DepartmentManagementPage.css";
// import { getSerialNumber } from "../../utils/pagination";
// import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   unit_id: "",
//   parent_department_id: "",
//   manager_user_id: "",
// };

// export default function DepartmentManagementPage() {
//   const { can } = usePermissions();

//   const [departments, setDepartments] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [units, setUnits] = useState([]);
//   const [users, setUsers] = useState([]);

//   const [search, setSearch] = useState("");
//   const [unitFilter, setUnitFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState(""); // "" | "1" | "0"

//   const [sortField, setSortField] = useState("name");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   useEffect(() => {
//     fetchDepartments();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, unitFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchDropdownData = async () => {
//     try {
//       const [unitRes, userRes] = await Promise.all([api.get("/units"), api.get("/users")]);
//       setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
//       setUsers(Array.isArray(userRes.data) ? userRes.data : []);
//     } catch (err) {
//       console.error("Dropdown fetch error:", err);
//     }
//   };

//   const fetchDepartments = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/departments", {
//         params: {
//           search: search || undefined,
//           unit_id: unitFilter || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setDepartments(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch departments error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch departments");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const unitMap = useMemo(
//     () => Object.fromEntries(units.map((u) => [String(u.id), u.name])),
//     [units]
//   );

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setShowModal(true);
//   };

//   const openEdit = (dept) => {
//     setForm({
//       name: dept.name || "",
//       code: dept.code || "",
//       description: dept.description || "",
//       unit_id: dept.unit_id || "",
//       parent_department_id: dept.parent_department_id || "",
//       manager_user_id: dept.manager_user_id || "",
//     });
//     setEditId(dept.id);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Department name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       code: form.code.trim() || undefined,
//       description: form.description.trim() || null,
//       unit_id: form.unit_id || null,
//       parent_department_id: form.parent_department_id || null,
//       manager_user_id: form.manager_user_id || null,
//     };

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/departments/${editId}`, payload);
//         toast.success("Department updated");
//       } else {
//         await api.post("/departments", payload);
//         toast.success("Department created");
//       }
//       closeModal();
//       fetchDepartments();
//     } catch (err) {
//       console.error("Save department error:", err);
//       toast.error(err.response?.data?.message || "Failed to save department");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (dept) => {
//     try {
//       await api.patch(`/departments/${dept.id}/status`, { is_active: !dept.is_active });
//       toast.success(dept.is_active ? "Department deactivated" : "Department activated");
//       fetchDepartments();
//     } catch (err) {
//       console.error("Toggle status error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const openDeleteModal = (dept) => {
//     setDeleteTarget(dept);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/departments/${deleteTarget.id}`);
//       toast.success("Department deleted");
//       closeDeleteModal();
//       fetchDepartments();
//     } catch (err) {
//       console.error("Delete department error:", err);
//       const data = err.response?.data;
//       if (data?.code === "DEPARTMENT_IN_USE") {
//         const d = data.details?.dependents || {};
//         toast.error(
//           `Cannot delete: referenced by ${d.users || 0} user(s), ${d.designations || 0} designation(s), ${d.childDepartments || 0} sub-department(s). Deactivate instead.`
//         );
//       } else {
//         toast.error(data?.message || "Failed to delete department");
//       }
//       closeDeleteModal();
//     }
//   };

//   return (
//     <div className="unit-page dept-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Department Management</h2>
//           <p>Manage organizational departments, hierarchy and unit assignments.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchDepartments}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="departments" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Department
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="dept-stat-icon dept-stat-icon-primary">
//             <i className="fa-solid fa-building" aria-hidden="true"></i>
//           </div>
//           <div className="dept-stat-text">
//             <span>Total Departments</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="dept-stat-icon dept-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="dept-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-sitemap dept-list-icon" aria-hidden="true"></i>
//               Department List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete departments.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 260 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 180 }}
//               value={unitFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setUnitFilter(e.target.value);
//               }}
//             >
//               <option value="">All Units</option>
//               {units.map((u) => (
//                 <option key={u.id} value={u.id}>
//                   {u.name}
//                 </option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 160 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading departments...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: 70 }}>S.NO.</th>
//                   <th className="sortable" onClick={() => handleSort("name")}>
//                     Name {sortIcon("name")}
//                   </th>
//                   <th className="sortable" onClick={() => handleSort("code")}>
//                     Code {sortIcon("code")}
//                   </th>
//                   <th>Unit</th>
//                   <th>Parent Department</th>
//                   <th>Manager</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>
//                     Status {sortIcon("is_active")}
//                   </th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {departments.length > 0 ? (
//                   departments.map((dept, index) => (
//                     <tr key={dept.id}>
//                       <td>{getSerialNumber(index, currentPage, pageSize)}</td>
//                       <td className="dept-col-name">
//                         <strong className="dept-truncate" title={dept.name}>{dept.name}</strong>
//                       </td>
//                       <td>{dept.code || <span className="dept-muted">—</span>}</td>
//                       <td>{dept.unit_name || unitMap[String(dept.unit_id)] || <span className="dept-muted">—</span>}</td>
//                       <td>{dept.parent_department_name || <span className="dept-muted">—</span>}</td>
//                       <td>{dept.manager_name || <span className="dept-muted">—</span>}</td>
//                       <td>
//                         <Badge className={`unit-status${dept.is_active ? "" : " unit-status-inactive"}`}>
//                           {dept.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td className="dept-col-actions">
//                         <div className="unit-actions">
//                           <Can moduleKey="departments" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit Department"
//                               aria-label="Edit Department"
//                               onClick={() => openEdit(dept)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("departments", "activate") || can("departments", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn dept-toggle"
//                               title={dept.is_active ? "Deactivate Department" : "Activate Department"}
//                               aria-label={dept.is_active ? "Deactivate Department" : "Activate Department"}
//                               onClick={() => toggleStatus(dept)}
//                             >
//                               <i className={`fa-solid ${dept.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="departments" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete Department"
//                               aria-label="Delete Department"
//                               onClick={() => openDeleteModal(dept)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="8">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
//                         </div>
//                         <h5>No departments found</h5>
//                         <p>Try another search or add a new department.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{departments.length}</strong> of <strong>{total}</strong> departments
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((p) => p - 1)}
//               />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((p) => p + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showModal}
//         onHide={closeModal}
//         centered
//         className="unit-modal dept-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <AccountTreeOutlinedIcon className="modal-header-icon" aria-hidden="true" />
//             <Modal.Title>{editId ? "Edit Department" : "Add New Department"}</Modal.Title>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Information Technology"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code (optional — derived from name if blank)</Form.Label>
//               <Form.Control
//                 placeholder="e.g. IT"
//                 value={form.code}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Unit (optional)</Form.Label>
//               <Form.Select
//                 value={form.unit_id}
//                 onChange={(e) => handleChange("unit_id", e.target.value)}
//               >
//                 <option value="">Global (no unit)</option>
//                 {units.map((u) => (
//                   <option key={u.id} value={u.id}>
//                     {u.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Parent Department (optional)</Form.Label>
//               <Form.Select
//                 value={form.parent_department_id}
//                 onChange={(e) => handleChange("parent_department_id", e.target.value)}
//               >
//                 <option value="">None (top-level)</option>
//                 {departments
//                   .filter((d) => d.id !== editId)
//                   .map((d) => (
//                     <option key={d.id} value={d.id}>
//                       {d.name}
//                     </option>
//                   ))}
//               </Form.Select>
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Manager (optional)</Form.Label>
//               <Form.Select
//                 value={form.manager_user_id}
//                 onChange={(e) => handleChange("manager_user_id", e.target.value)}
//               >
//                 <option value="">Unassigned</option>
//                 {users.map((u) => (
//                   <option key={u.id} value={u.id}>
//                     {u.name}
//                   </option>
//                 ))}
//               </Form.Select>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>
//             Cancel
//           </Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Department" : "Create Department"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={showDeleteModal}
//         onHide={closeDeleteModal}
//         centered
//         className="unit-modal dept-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm admin-teal-modal-danger"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <Modal.Title>Delete Department?</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="admin-modal-danger-icon" aria-hidden="true">
//             <DeleteOutlineIcon fontSize="inherit" />
//           </div>
//           <p className="unit-delete-text text-center">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If other records reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
//             Cancel
//           </Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "../../theme/adminIconField.css";
import "./DepartmentManagementPage.css";
import { getSerialNumber } from "../../utils/pagination";

const initialForm = {
  name: "",
  code: "",
  description: "",
  unit_id: "",
  parent_department_id: "",
  manager_user_id: "",
};

export default function DepartmentManagementPage() {
  const { can } = usePermissions();

  const [departments, setDepartments] = useState([]);
  const [total, setTotal] = useState(0);
  const [units, setUnits] = useState([]);
  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");
  const [unitFilter, setUnitFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // "" | "1" | "0"

  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchDepartments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, unitFilter, statusFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchDropdownData = async () => {
    try {
      const [unitRes, userRes] = await Promise.all([api.get("/units"), api.get("/users")]);
      setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
      setUsers(Array.isArray(userRes.data) ? userRes.data : []);
    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const res = await api.get("/departments", {
        params: {
          search: search || undefined,
          unit_id: unitFilter || undefined,
          is_active: statusFilter === "" ? undefined : statusFilter,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setDepartments(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch departments error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch departments");
    } finally {
      setLoading(false);
    }
  };

  const unitMap = useMemo(
    () => Object.fromEntries(units.map((u) => [String(u.id), u.name])),
    [units]
  );

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setShowModal(true);
  };

  const openEdit = (dept) => {
    setForm({
      name: dept.name || "",
      code: dept.code || "",
      description: dept.description || "",
      unit_id: dept.unit_id || "",
      parent_department_id: dept.parent_department_id || "",
      manager_user_id: dept.manager_user_id || "",
    });
    setEditId(dept.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Department name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      code: form.code.trim() || undefined,
      description: form.description.trim() || null,
      unit_id: form.unit_id || null,
      parent_department_id: form.parent_department_id || null,
      manager_user_id: form.manager_user_id || null,
    };

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/departments/${editId}`, payload);
        toast.success("Department updated");
      } else {
        await api.post("/departments", payload);
        toast.success("Department created");
      }
      closeModal();
      fetchDepartments();
    } catch (err) {
      console.error("Save department error:", err);
      toast.error(err.response?.data?.message || "Failed to save department");
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (dept) => {
    try {
      await api.patch(`/departments/${dept.id}/status`, { is_active: !dept.is_active });
      toast.success(dept.is_active ? "Department deactivated" : "Department activated");
      fetchDepartments();
    } catch (err) {
      console.error("Toggle status error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const openDeleteModal = (dept) => {
    setDeleteTarget(dept);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/departments/${deleteTarget.id}`);
      toast.success("Department deleted");
      closeDeleteModal();
      fetchDepartments();
    } catch (err) {
      console.error("Delete department error:", err);
      const data = err.response?.data;
      if (data?.code === "DEPARTMENT_IN_USE") {
        const d = data.details?.dependents || {};
        toast.error(
          `Cannot delete: referenced by ${d.users || 0} user(s), ${d.designations || 0} designation(s), ${d.childDepartments || 0} sub-department(s). Deactivate instead.`
        );
      } else {
        toast.error(data?.message || "Failed to delete department");
      }
      closeDeleteModal();
    }
  };

  return (
    <div className="unit-page dept-mgmt-theme">

      <div className="department-heading-box">
        <div className="department-heading-content">
          <div className="department-heading-icon">
            <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Department Management</h2>
            <p>Manage organizational departments, hierarchy and unit assignments.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchDepartments}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="departments" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Department
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card department-stat-blue">
          <div className="department-stat-content">
            <div className="dept-stat-text">
              <span>Total Departments</span>
              <strong>{total}</strong>
            </div>

            <div className="dept-stat-icon">
              <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card department-stat-purple">
          <div className="department-stat-content">
            <div className="dept-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="dept-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card department-stat-green">
          <div className="department-stat-content">
            <div className="dept-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="dept-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="department-section-title">
            <div className="department-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Department List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete departments.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size department-filter-unit"
              value={unitFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setUnitFilter(e.target.value);
              }}
            >
              <option value="">All Units</option>
              {units.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="unit-page-size department-filter-status"
              value={statusFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusFilter(e.target.value);
              }}
            >
              <option value="">All Statuses</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </Form.Select>

            <Form.Select
              className="unit-page-size department-filter-page"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading departments...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>S.NO.</th>
                  <th className="sortable" onClick={() => handleSort("name")}>
                    Name {sortIcon("name")}
                  </th>
                  <th className="sortable" onClick={() => handleSort("code")}>
                    Code {sortIcon("code")}
                  </th>
                  <th>Unit</th>
                  <th>Parent Department</th>
                  <th>Manager</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>
                    Status {sortIcon("is_active")}
                  </th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {departments.length > 0 ? (
                  departments.map((dept, index) => (
                    <tr key={dept.id}>
                      <td>{getSerialNumber(index, currentPage, pageSize)}</td>
                      <td className="dept-col-name">
                        <div className="unit-name-box">
                          <div className="unit-letter">
                            {dept.name?.charAt(0)?.toUpperCase() || "D"}
                          </div>

                          <div className="department-name-copy">
                            <strong className="dept-truncate" title={dept.name}>
                              {dept.name}
                            </strong>
                            <small>Department ID: {dept.id}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        {dept.code ? (
                          <span className="department-code-chip">
                            <i className="fa-solid fa-code" aria-hidden="true"></i>
                            {dept.code}
                          </span>
                        ) : (
                          <span className="dept-muted">—</span>
                        )}
                      </td>
                      <td>
                        {dept.unit_name || unitMap[String(dept.unit_id)] ? (
                          <Badge className="unit-status department-unit-badge">
                            <i className="fa-solid fa-building me-1" aria-hidden="true"></i>
                            {dept.unit_name || unitMap[String(dept.unit_id)]}
                          </Badge>
                        ) : (
                          <span className="dept-muted">—</span>
                        )}
                      </td>
                      <td>
                        {dept.parent_department_name ? (
                          <span className="department-parent-chip">
                            <i className="fa-solid fa-diagram-project" aria-hidden="true"></i>
                            {dept.parent_department_name}
                          </span>
                        ) : (
                          <span className="dept-muted">Top-level</span>
                        )}
                      </td>
                      <td>
                        {dept.manager_name ? (
                          <span className="department-manager-chip">
                            <i className="fa-regular fa-user" aria-hidden="true"></i>
                            {dept.manager_name}
                          </span>
                        ) : (
                          <span className="dept-muted">Unassigned</span>
                        )}
                      </td>
                      <td>
                        <Badge
                          className={`unit-status ${
                            dept.is_active
                              ? "department-status-active"
                              : "department-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              dept.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {dept.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td className="dept-col-actions">
                        <div className="unit-actions">
                          <Can moduleKey="departments" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit Department"
                              aria-label="Edit Department"
                              onClick={() => openEdit(dept)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("departments", "activate") || can("departments", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn dept-toggle ${
                                dept.is_active ? "dept-toggle-off" : "dept-toggle-on"
                              }`}
                              title={dept.is_active ? "Deactivate Department" : "Activate Department"}
                              aria-label={dept.is_active ? "Deactivate Department" : "Activate Department"}
                              onClick={() => toggleStatus(dept)}
                            >
                              <i className={`fa-solid ${dept.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="departments" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title="Delete Department"
                              aria-label="Delete Department"
                              onClick={() => openDeleteModal(dept)}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-sitemap" aria-hidden="true"></i>
                        </div>
                        <h5>No departments found</h5>
                        <p>Try another search or add a new department.</p>

                        <Can moduleKey="departments" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Department
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{departments.length}</strong> of <strong>{total}</strong> departments
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item
                  key={i + 1}
                  active={i + 1 === currentPage}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal dept-modal"
        dialogClassName="department-admin-modal department-admin-modal-lg"
        backdropClassName="department-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="department-modal-heading">
            <div className="department-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-sitemap"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Department Setup</small>
              <Modal.Title>{editId ? "Edit Department" : "Add New Department"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6 admin-form-col">
              <Form.Label htmlFor="department-name">Name</Form.Label>
              <div className="admin-icon-field">
                <i className="fa-solid fa-building" aria-hidden="true"></i>
                <Form.Control
                  id="department-name"
                  placeholder="e.g. Information Technology"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6 admin-form-col">
              <Form.Label htmlFor="department-code">Code (optional — derived from name if blank)</Form.Label>
              <div className="admin-icon-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  id="department-code"
                  placeholder="e.g. IT"
                  value={form.code}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-12 admin-form-col">
              <Form.Label htmlFor="department-description">Description</Form.Label>
              <Form.Control
                id="department-description"
                as="textarea"
                rows={2}
                value={form.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="department-unit">Unit (optional)</Form.Label>
              <Form.Select
                id="department-unit"
                value={form.unit_id}
                onChange={(e) => handleChange("unit_id", e.target.value)}
              >
                <option value="">Global (no unit)</option>
                {units.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="department-parent">Parent Department (optional)</Form.Label>
              <Form.Select
                id="department-parent"
                value={form.parent_department_id}
                onChange={(e) => handleChange("parent_department_id", e.target.value)}
              >
                <option value="">None (top-level)</option>
                {departments
                  .filter((d) => d.id !== editId)
                  .map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
              </Form.Select>
            </div>

            <div className="col-md-4 admin-form-col">
              <Form.Label htmlFor="department-manager">Manager (optional)</Form.Label>
              <Form.Select
                id="department-manager"
                value={form.manager_user_id}
                onChange={(e) => handleChange("manager_user_id", e.target.value)}
              >
                <option value="">Unassigned</option>
                {users.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Department" : "Create Department"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal dept-modal"
        dialogClassName="department-admin-modal department-admin-modal-sm department-admin-modal-danger"
        backdropClassName="department-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="department-modal-heading">
            <div className="department-modal-icon department-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Department?</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="department-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-sitemap"></i>
          </div>
          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If other records reference it, deletion will be blocked — deactivate it instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
